import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
import { Link, useParams } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "../../Config/swal.css";
import { Input, Select } from "antd";
import { useLocation } from "react-router-dom";
import { Footer } from "../footer/footer";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { TextArea } = Input;

export default function ViewExpense() {
  //   const { ExpenseID } = useParams();

  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);
  const location = useLocation();

  const ExpensesData = location.state?.ExpensesData;

  console.log(ExpensesData, "expensessssssss");

  const [loading, setLoading] = useState(false);
  const [expenseData, setExpenseData] = useState(ExpensesData || {});

  useEffect(() => {
    if (ExpensesData) {
      setExpenseData(ExpensesData);
    }
  }, [ExpensesData]);

  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [isEditing, setIsEditing] = useState(false);

  const [userDetails, SetUserDetails] = useState([]);
  const userId = userDetails?.userId || userDetails?.staffid;

  const [customersData, setCustomersData] = useState([]);
  const [selectedCustomerid, setSelectedCustomerid] = useState("");

  const [categoriesData, setCategoriesData] = useState([]);
  const [selectedCategoryid, setSelectedCategoryid] = useState("");

  const [paymentModeData, setPaymentModeData] = useState([]);
  const [selectedPaymentid, setSelectedPaymentid] = useState("");

  const [taxesData, setTaxesData] = useState([]);
  const [selectedTaxid, setSelectedTaxid] = useState("");

  const [currencyData, setCurrencyData] = useState([]);
  const [selectedCurrencyId, setSelectedCurrencyId] = useState("");

  const [selectedDate, setSelectedDate] = useState("");

  const [editFile, setEditFile] = useState(null);
  const [editFilePreview, setEditFilePreview] = useState(null);

  const [projectOptions, setProjectOptions] = useState([]);
  const [projectLoading, setProjectLoading] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );
    SetUserDetails(userDetailsSession);
  }, []);

  const [formValues, setFormValues] = useState({
    category: "",
    currency: "",
    amount: "",
    tax: "",
    note: "",
    expense_name: "",
    clientid: "",
    project_id: "",
    paymentmode: "",
    date: "",
  });

  useEffect(() => {
    if (ExpensesData) {
      setFormValues({
        amount: ExpensesData.amount || "",

        note: ExpensesData.note || "",
        expense_name: ExpensesData.expense_name || "",

        project_id: ExpensesData.project_id || 0,

        date: ExpensesData.date ? ExpensesData.date.split("T")[0] : "",
      });
      setSelectedCustomerid(Number(ExpensesData.clientid));
      setSelectedCategoryid(Number(ExpensesData.category));
      setSelectedCurrencyId(Number(ExpensesData.currency));
      setSelectedPaymentid(Number(ExpensesData.paymentmode));
      setSelectedTaxid(Number(ExpensesData.tax));
    }
    if (ExpensesData.project_id) {
      getProjects(ExpensesData.clientid);
      setSelectedProject(Number(ExpensesData.project_id));
    }
  }, [ExpensesData]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [
          customersResponse,
          categoriesResponse,
          paymentModesResponse,
          taxesResponse,
          currencyResponse,
        ] = await Promise.all([
          fetch(`${API_BASE_CRM_URL}customers/GetCustomers`),
          fetch(`${API_BASE_CRM_URL}expenses/GetExpenseCategories`),
          fetch(`${API_BASE_CRM_URL}expenses/GetPaymentModes`),
          fetch(`${API_BASE_CRM_URL}GetTaxes`),
          fetch(`${API_BASE_CRM_URL}GetCurrencies`),
        ]);

        if (
          !customersResponse.ok ||
          !categoriesResponse.ok ||
          !paymentModesResponse.ok ||
          !taxesResponse.ok ||
          !currencyResponse.ok
        ) {
          throw new Error("Failed to fetch data");
        }

        const customersData = await customersResponse.json();
        const categoriesData = await categoriesResponse.json();
        const paymentModesData = await paymentModesResponse.json();
        const taxesData = await taxesResponse.json();
        const currencyData = await currencyResponse.json();

        if (customersData.Status) setCustomersData(customersData.ResultData);
        if (categoriesData.Status) setCategoriesData(categoriesData.ResultData);
        if (paymentModesData.Status)
          setPaymentModeData(paymentModesData.ResultData);
        if (taxesData.Status) setTaxesData(taxesData.ResultData);
        if (currencyData.Status) setCurrencyData(currencyData.Data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAllData();
  }, []);

  const getProjects = async (customerId) => {
    try {
      setProjectLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}project/GetProjectsByCusId?CusID=${customerId}`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setProjectOptions(options);
      } else {
        setProjectOptions([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjectOptions([]);
    } finally {
      setProjectLoading(false);
    }
  };

  const customerOptions =
    customersData &&
    customersData.map((item) => ({
      value: item.customerId,
      label: item.company,
    }));

  const categoryOptions =
    categoriesData &&
    categoriesData.map((item) => ({
      value: item.id,
      label: item.name,
    }));

  const taxOptions =
    taxesData &&
    taxesData.map((item) => ({
      value: item.Id,
      label: item.Name,
    }));

  const paymentModeOptions =
    paymentModeData &&
    paymentModeData.map((item) => ({
      value: item.id,
      label: item.name,
    }));

  const currencyOptions =
    currencyData &&
    currencyData.map((item) => ({
      value: item.id,
      label: item.name,
    }));

  const handleCustomerChange = (selectedone) => {
    setSelectedCustomerid(selectedone);
    setFormValues((prevData) => ({
      ...prevData,
      clientid: selectedone,
    }));
  };

  const handleCategoryChange = (selectedone) => {
    setSelectedCategoryid(selectedone);
    setFormValues((prevData) => ({
      ...prevData,
      category: selectedone,
    }));
  };

  const handleTaxChange = (selectedone) => {
    setSelectedTaxid(selectedone);
    setFormValues((prevData) => ({
      ...prevData,
      tax: selectedone,
    }));
  };

  const handlePaymentChange = (selectedone) => {
    setSelectedPaymentid(selectedone);
  };

  const handleCurrencyChange = (selectedone) => {
    setSelectedCurrencyId(selectedone);
    setFormValues((prevData) => ({
      ...prevData,
      currency: selectedone,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleEditFileChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const maxSize = 2 * 1024 * 1024; // 2 MB

    if (file.size > maxSize) {
      Swal.fire({
        title: "File Too Large",
        text: "Maximum file size allowed is 2 MB.",
        icon: "warning",
      });

      e.target.value = "";
      return;
    }

    setEditFile(file);

    if (file.type.startsWith("image/")) {
      setEditFilePreview(URL.createObjectURL(file));
    } else {
      setEditFilePreview(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("id", ExpensesData?.id);
      formDataToSend.append("category", selectedCategoryid || "");
      formDataToSend.append("currency", ExpensesData.currency);
      formDataToSend.append("amount", Number(formValues.amount) || 0);
      formDataToSend.append("tax", selectedTaxid || "");
      formDataToSend.append("note", formValues.note || "");
      formDataToSend.append("expense_name", formValues.expense_name || "");
      formDataToSend.append("clientid", selectedCustomerid || "");
      // formDataToSend.append("project_id", formValues.project_id || 0);
      formDataToSend.append("paymentmode", selectedPaymentid || "");
      formDataToSend.append("date", formValues.date || selectedDate || "");
      formDataToSend.append("tax2", ExpensesData?.tax2);
      formDataToSend.append("send_invoice_to_customer", 0);
      formDataToSend.append("addedfrom", userId || "");
      formDataToSend.append("project_id", selectedProject || "");

      formDataToSend.append("reference", ExpensesData.reference_no);

      // Add file only when user selects a new file
      if (editFile) {
        formDataToSend.append("file", editFile);
      }

      const response = await fetch(
        `${API_BASE_CRM_URL}expenses/UpdateExpense`,
        {
          method: "POST",
          body: formDataToSend,
        },
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();

      if (result.Status) {
        setLoading(false);

        Swal.fire({
          title: "Expense Updated Successfully.",
          icon: "success",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            navigate("/expenses");
          }
        });
      } else {
        setLoading(false);

        Swal.fire({
          title: "Error",
          text: result.Message || "Failed to update expense.",
          icon: "error",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        });
      }
    } catch (error) {
      console.error("Error:", error);

      setLoading(false);

      Swal.fire({
        title: "Error",
        text: "An error occurred while updating the expense.",
        icon: "error",
      });
    }
  };

  return (
    <Base>
      <div className="page-heade mb-3">
        <div className="row align-items-center">
          <div className="col-7">
            <div className="page-title">
              <h4>Expense Details</h4>
            </div>
          </div>

          <div className="col-5 d-flex justify-content-end">
            <Link to="/expenses">
              <button className="btn btn-secondary btn-sm">
                <i className="fa-solid fa-list"></i>
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="col-xxl-12 col-xl-12">
        <div className="container-fluid p-2">
          {isEditing ? (
            <div className="card shadow-sm border-0">
              <div className="card-body">
                <div className="d-flex justify-content-between border-bottom pb-2 mb-2">
                  <h5 className="mb-0">
                    <i className="fa-solid fa-pen-to-square me-2 text-primary"></i>
                    Edit Expense
                  </h5>

                  <i
                    className="fa-solid fa-xmark"
                    style={{ cursor: "pointer", fontSize: "18px" }}
                    onClick={() => setIsEditing(false)}
                  ></i>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="row  g-3">
                    <div className="col-md-4">
                      <Input
                        placeholder="Expense Name"
                        name="expense_name"
                        size="large"
                        value={formValues.expense_name}
                        onChange={handleChange}
                        prefix={
                          <i className="fa-solid fa-file-invoice-dollar text-muted" />
                        }
                      />
                    </div>

                    <div className="col-md-4">
                      <DatePicker
                        size="large"
                        value={formValues?.date ? dayjs(formValues.date) : null}
                        format="DD-MM-YYYY"
                        style={{ width: "100%" }}
                        prefix={
                          <i className="fa-solid fa-calendar-days text-muted" />
                        }
                        onChange={(date) => {
                          setFormValues((prev) => ({
                            ...prev,
                            date: date ? date.format("YYYY-MM-DD") : "",
                          }));
                        }}
                      />
                    </div>

                    <div className="col-6">
                      <Input
                        type="number"
                        name="amount"
                        size="large"
                        value={formValues.amount}
                        placeholder="Amount"
                        onChange={handleChange}
                        prefix={
                          <i className="fa-solid fa-indian-rupee-sign text-muted" />
                        }
                      />
                    </div>

                    <div className="col-6">
                      <Select
                        showSearch
                        size="large"
                        placeholder="Category"
                        value={selectedCategoryid || null}
                        onChange={handleCategoryChange}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={categoryOptions}
                        style={{ width: "100%" }}
                        suffixIcon={<i className="fa-solid fa-layer-group" />}
                      />
                    </div>

                    <div className="col-6">
                      <Select
                        showSearch
                        placeholder="Customer"
                        size="large"
                        value={selectedCustomerid || null}
                        onChange={(value) => {
                          setSelectedCustomerid(value);
                          // setFormData((prev) => ({
                          //   ...prev,
                          //   clientid: value,
                          // }));

                          handleCustomerChange(value);
                          getProjects(value);

                          // Clear previous project when customer changes
                          setSelectedProject(null);
                          // setFormData((prev) => ({
                          //   ...prev,
                          //   project_id: "",
                          // }));
                        }}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={customerOptions}
                        style={{ width: "100%" }}
                        suffixIcon={<i className="fa-solid fa-building-user" />}
                      />
                    </div>
                    {selectedCustomerid && (
                      <div className="col-6 mb-3">
                        <Select
                          placeholder="Select Project"
                          style={{ width: "100%", height: 38 }}
                          allowClear
                          showSearch
                          optionFilterProp="label"
                          loading={projectLoading}
                          options={projectOptions}
                          value={selectedProject}
                          onChange={(value) => {
                            setSelectedProject(value);
                          }}
                        />
                      </div>
                    )}

                    <div className="col-6 d-none">
                      <Select
                        showSearch
                        placeholder="Currency"
                        size="large"
                        value={selectedCurrencyId || null}
                        onChange={handleCurrencyChange}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={currencyOptions}
                        style={{ width: "100%" }}
                        suffixIcon={
                          <i className="fa-solid fa-money-bill-wave" />
                        }
                      />
                    </div>

                    <div className="col-6">
                      <Select
                        showSearch
                        placeholder="Tax"
                        size="large"
                        value={selectedTaxid || null}
                        onChange={handleTaxChange}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={taxOptions.map((option) => ({
                          ...option,
                          key: option.key,
                        }))}
                        style={{ width: "100%" }}
                        suffixIcon={<i className="fa-solid fa-percent" />}
                      />
                    </div>

                    <div className="col-6">
                      <Select
                        showSearch
                        size="large"
                        placeholder="Payment Mode"
                        value={selectedPaymentid || null}
                        onChange={handlePaymentChange}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={paymentModeOptions}
                        style={{ width: "100%" }}
                        suffixIcon={<i className="fa-solid fa-credit-card" />}
                      />
                    </div>

                    <div className="col-12">
                      <TextArea
                        rows={4}
                        size="large"
                        name="note"
                        value={formValues.note}
                        placeholder="Description"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-12">
                      <label className="form-label fw-semibold">
                        Attachment
                      </label>

                      <div className="d-flex align-items-center gap-2">
                        <label
                          htmlFor="edit-expense-file"
                          className="btn btn-outline-primary"
                          style={{
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                        >
                          <i className="fa-solid fa-paperclip me-2"></i>
                          {editFile ? "Upload File" : "Change File"}
                        </label>

                        <input
                          id="edit-expense-file"
                          type="file"
                          accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                          onChange={handleEditFileChange}
                          style={{ display: "none" }}
                        />
                      </div>

                      {/* New selected file */}
                      {editFile && (
                        <div className="mt-3 border rounded p-2">
                          {editFile.type.startsWith("image/") ? (
                            <img
                              src={editFilePreview}
                              alt={editFile.name}
                              style={{
                                width: "100%",
                                height: "200px",
                                objectFit: "contain",
                                borderRadius: "8px",
                                background: "#f8f9fa",
                              }}
                            />
                          ) : (
                            <div className="d-flex align-items-center">
                              <i
                                className={`fa-solid ${
                                  editFile.type === "application/pdf"
                                    ? "fa-file-pdf text-danger"
                                    : "fa-file text-primary"
                                } me-3`}
                                style={{ fontSize: "28px" }}
                              ></i>

                              <span>{editFile.name}</span>
                            </div>
                          )}
                        </div>
                      )}

                      {/* Existing attachment */}
                      {!editFile && expenseData?.external_link && (
                        <div className="mt-3 border rounded p-2">
                          {expenseData.filetype?.startsWith("image/") ? (
                            <img
                              src={expenseData.external_link}
                              alt={expenseData.file_name}
                              style={{
                                width: "100%",
                                height: "200px",
                                objectFit: "contain",
                                borderRadius: "8px",
                                background: "#f8f9fa",
                              }}
                            />
                          ) : (
                            <div className="d-flex align-items-center p-2">
                              <i
                                className={`fa-solid ${
                                  expenseData.filetype === "application/pdf"
                                    ? "fa-file-pdf text-danger"
                                    : "fa-file text-primary"
                                } me-3`}
                                style={{ fontSize: "28px" }}
                              ></i>

                              <span>{expenseData.file_name}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* <div className="text-center mt-2">
                    <button
                      type="submit"
                      className="btn"
                      style={{
                        backgroundColor: "#0A1F3E",
                        borderColor: "#0A1F3E",
                        borderRadius: "10px",
                        minWidth: "150px",
                        color:"#ffff"
                      }}
                    >
                      {loading ? "Submitting..." : "Update Expense"}
                    </button>
                  </div> */}

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    {/* Cancel */}
                    <div
                      onClick={() => setIsEditing(false)}
                      style={{
                        width: "38px",
                        height: "38px",
                        background: "#fff",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                      }}
                    >
                      <i
                        className="fa-solid fa-xmark"
                        style={{
                          color: "#dc3545",
                          fontSize: "16px",
                        }}
                      />
                    </div>

                    {/* Save */}
                    <div
                      onClick={handleSubmit}
                      style={{
                        width: "38px",
                        height: "38px",
                        background: "#fff",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                      }}
                    >
                      <i
                        className={`fa-solid ${
                          loading ? "fa-spinner fa-spin" : "fa-check"
                        }`}
                        style={{
                          color: "#198754",
                          fontSize: "16px",
                        }}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          ) : (
            <div className="card shadow-sm border-0">
              <div className="card-body">
                {/* Expense Information */}
                <div className="mb-3">
                  <div className="d-flex justify-content-between border-bottom pb-2 mb-3">
                    <h5 className="mb-0">
                      <i className="fa-solid fa-file-invoice-dollar me-2 text-primary"></i>
                      Expense Details
                    </h5>

                    <i
                      className="fa-solid fa-pen-to-square"
                      style={{
                        cursor: "pointer",
                        color: "#1B2850",
                        fontSize: "18px",
                      }}
                      onClick={() => setIsEditing(true)}
                    ></i>
                  </div>

                  <div className="row g-3">
                    <div className="col-6">
                      <p>
                        {" "}
                        <i className="fas fa-tag text-muted me-2"></i>
                        {expenseData?.expense_name || "N/A"}
                      </p>
                    </div>

                    <div className="col-6">
                      <p>
                        {" "}
                        <i className="fas fa-calendar-days text-muted me-2"></i>
                        {formatDate(expenseData?.date) || "N/A"}
                      </p>
                    </div>

                    <div className="col-6">
                      <p>
                        {" "}
                        <i className="fas fa-indian-rupee-sign text-muted me-2"></i>
                        {expenseData?.amount || 0}
                      </p>
                    </div>

                    <div className="col-6">
                      <p>
                        {" "}
                        <i className="fas fa-layer-group text-muted me-2"></i>
                        {expenseData?.expense_category_name || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Customer Details */}
                <div className="mb-4">
                  <h6 className="border-bottom pb-2 mb-3">
                    <i className="fas fa-user-tie me-2 text-success"></i>
                    Customer Details
                  </h6>

                  <div className="row g-3">
                    <div className="col-7 ">
                      <div className="d-flex align-items-center">
                        <p>
                          {" "}
                          <i className="fas fa-building-user text-muted me-2"></i>
                          {expenseData?.client_name || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="col-5">
                      <div className="d-flex align-items-center">
                        <p>
                          {" "}
                          <i class="fa-solid fa-diagram-project me-2"></i>
                          {expenseData?.project_name || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Payment Details */}
                <div className="mb-4 mt-4">
                  <h6 className="border-bottom pb-2 mb-3">
                    <i className="fas fa-credit-card me-2 text-warning"></i>
                    Payment Details
                  </h6>

                  <div className="row g-3">
                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <p>
                          {" "}
                          <i className="fas fa-receipt text-muted me-2"></i>
                          {expenseData?.taxName || "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <p>
                          {" "}
                          <i className="fas fa-wallet text-muted me-2"></i>
                          {expenseData?.payment_mode_name || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Description */}
                <div className="mb-3">
                  <h6 className="border-bottom pb-1">
                    <i className="fas fa-file-alt me-2 text-secondary"></i>
                    Description
                  </h6>

                  <div className="d-flex align-items-start mt-3">
                    <span>
                      {" "}
                      <i className="fas fa-align-left text-muted me-3 mt-1 "></i>
                      {expenseData?.note || "N/A"}
                    </span>
                  </div>
                </div>

                {expenseData?.external_link && (
                  <div className="mt-3">
                    {expenseData?.filetype?.startsWith("image/") ? (
                      <>
                        <img
                          src={expenseData.external_link}
                          alt={expenseData.file_name || "Attachment"}
                          style={{
                            width: "100%",
                            height: "300px",
                            objectFit: "contain",
                            borderRadius: "8px",
                            border: "1px solid #dee2e6",
                            background: "#f8f9fa",
                          }}
                        />

                        <div className="text-end mt-2">
                          <a
                            href={expenseData.external_link}
                            download={expenseData.file_name}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-primary"
                          >
                            <i className="fas fa-download"></i>
                          </a>
                        </div>
                      </>
                    ) : expenseData?.filetype === "application/pdf" ? (
                      <>
                        <iframe
                          src={expenseData.external_link}
                          title={expenseData.file_name || "PDF"}
                          style={{
                            width: "100%",
                            height: "400px",
                            border: "1px solid #dee2e6",
                            borderRadius: "8px",
                          }}
                        />

                        <div className="text-end mt-2">
                          <a
                            href={expenseData.external_link}
                            download={expenseData.file_name}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-danger"
                          >
                            <i className="fas fa-download"></i>
                          </a>
                        </div>
                      </>
                    ) : (
                      <div className="d-flex align-items-center justify-content-between border rounded p-3">
                        <div>
                          <i className="fas fa-file me-2 text-secondary"></i>
                          {expenseData.file_name || "Attachment"}
                        </div>

                        <a
                          href={expenseData.external_link}
                          download={expenseData.file_name}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-outline-primary"
                        >
                          <i className="fas fa-download"></i>
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer></Footer>
    </Base>
  );
}
